import React, { useEffect, useState } from "react";
import {
  ShareTopRightIcon,
  ShareLeftBottomIcon,
  ShareButtonIcon,
  LogoIcon,
} from "../../static/svg";
import params, { parse } from "../../utils/getParams";
import message from "../../components/message";
import { getParamByUrl } from "../../components/index";
import InitArea from "utils/block_text";
import NFT_01 from "assets/img/NFT_01.png";
import { Decrypt } from "../../utils/secret";
import "./index.less";
import { achievementsID, THIS_YEAR, keywordID } from "utils/consts";
import { KeyWordComponent } from "../keyword";
import { renderKeywordBackground, hiddenSensitiveMsg } from "utils/tool";

function InviterPage({ hideInviterPage, ...props }) {
  const t = window.t;
  const initArea = InitArea(props); // 初始化数据
  const [dataSoure, setDataSoure] = useState([]); // 要展示的数据
  const [params, setParams] = useState({}); // url 获取的数据
  const [title, setTitle] = useState("");
  const isKeyWord = params.id === keywordID;

  useEffect(() => {
    // 邀请链接  取值
    let p = getParamByUrl("p");
    let data = parse(Decrypt(p));
    // -1 全部模块
    if (data.id / 1 === -1 || data.id / 1 === achievementsID) {
      setDataSoure(initArea);
      setTitle(t("Your achievements"));
    } else if (data.id / 1 === keywordID) {
      // 关键词
      setDataSoure(initArea[+data.id - 2]);
      setTitle("");
    } else {
      setDataSoure(initArea[+data.id - 1]);
      setTitle(
        data.id / 1 === 19 ? t("NFTBtn") : initArea[+data.id - 1]?.title,
      );
    }
    setParams({ ...data, ...(data.id ? { id: data.id / 1 } : {}) });
    // 被邀请人  开启旅程 需要跳到 地球页
  }, []);
  useEffect(() => {
    // 判断邀请人 是否隐藏数据
    hiddenSensitiveMsg(params.show / 1);
  }, [params.show]);

  const getKeywordStyle = () => {
    let keywordStyle = {};
    if (isKeyWord) {
      keywordStyle = {
        background: renderKeywordBackground(dataSoure.personality.id),
      };
    }
    return keywordStyle;
  }

  const setFW700 = (text) => `<span class='fw-700'> ${text} </span>`;
  const { user_info = {} } = props;
  const { user_info: info = {} } = user_info;
  const { visit_bill_rank } = info;
  const setSpanHtml = (text) => `<span class="fw-700">${text}</span>`;
  return (
    <div className={`inviterPageWrap ${isKeyWord ? "keyword-inviter-container" : ""}`}>
      <div className="inviterPageContent">
        <div
          className="InviterHello fw-700"
          dangerouslySetInnerHTML={{
            __html: isKeyWord ? t("my.narrative.hello", {
              thisYear: THIS_YEAR,
            }) : t("Hi friend", { thisYear: THIS_YEAR }),
          }}
        ></div>
        <div className={`inviterMain linear-border`}>
          <div className={`inner-inviter  ${isKeyWord ? "keyword-inviter-inner" : ""}`} style={getKeywordStyle()}>

            <div className="iconBox">
              <span dangerouslySetInnerHTML={{ __html: LogoIcon() }}></span>
              <span dangerouslySetInnerHTML={{ __html: title }}></span>
            </div>
            {params.id === -1 || params.id === achievementsID ? (
              <div className="modalAll">
                <div className="shareModalImg">
                  <img src={dataSoure[dataSoure.length - 2].URL} alt="" />
                </div>
                <p className="title fw-700">{t("Congratulations")}</p>
                <p
                  className="textColor"
                  dangerouslySetInnerHTML={{
                    __html: t("link1"),
                  }}
                ></p>
                <p
                  className="textColor"
                  dangerouslySetInnerHTML={{
                    __html: t("link2", {
                      num: setFW700(visit_bill_rank),
                    }),
                  }}
                ></p>
                <p className="title fw-700">{t("Your achievements")}</p>
                {dataSoure.map((ele) => {
                  if (ele.id > 17) return;
                  return (
                    <div className="modalChild linear-border" key={ele.id}>
                      <div className="inner-modalChild">
                        <img src={ele.URL} alt="" />
                        <p
                          className="title fw-700"
                          dangerouslySetInnerHTML={{
                            __html: ele.title,
                          }}
                        ></p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: ele.text,
                          }}
                        ></div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : params.id === 19 ? (
              <div className="showNFT">
                <p className="title fw-700">{t("Congratulations")}</p>
                <p className="title fw-700">{t("Getting the Spaceman")}</p>
                <img src={NFT_01} alt="" />
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("Get 2022 Gate.io NFT souvenirs"),
                  }}
                ></p>
              </div>
            ) : params.id === keywordID ? (
              <KeyWordComponent isInvitePage dataSoure={dataSoure} annualData={props?.transaction?.annual_data || {}} />
            ) : (
              <div className="modalSingle">
                <div className="SingleChildren">
                  <div className="imgBox">
                    <img src={dataSoure.URL} alt="CheckpointPhoto" />
                  </div>
                  <div
                    id="centerner"
                    className="centerner"
                    dangerouslySetInnerHTML={{
                      __html: dataSoure.text,
                    }}
                  ></div>
                </div>
              </div>
            )}
            {
              !isKeyWord && (
                <div className="BgIconBox">
                  <div className="TopRightIcon">
                    <ShareTopRightIcon />
                  </div>
                  <div className="LeftBottomIcon">
                    <ShareLeftBottomIcon />
                  </div>
                  {/* <span className="ShareButtonIcon">
                    <ShareButtonIcon />
                  </span> */}
                </div>
              )
            }
          </div>
        </div>
      </div>
      <div className="inviter-button-wraper">
        <div
          className="StartMyJourney fw-700"
          onClick={() => {
            if (window.$$can_awake_up_app) {
              window.location.href = window.$$awake_target;
            } else {
              hideInviterPage();
              // 刷新页面
              window.location.href = window.location.origin + window.location.pathname;
            }
          }}
        >
          {t("Start my journey")}
        </div>
      </div>
    </div>
  );
}

export default InviterPage;
